import { DateFilter } from '../_models/filters/date-filter';

export function getDefaultDateFilters(): DateFilter {
  const date = new Date();

  let dateFrom = new Date(date.getFullYear(), date.getMonth(), 1);
  if (dateFrom < new Date(2025, 8, 1)) {
    dateFrom = new Date(2025, 8, 1);
  }
  const dateTo = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  return { dateFrom, dateTo };
}
